import React, { useState, useEffect } from "react";
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Checkbox,
    FormControlLabel
} from "@mui/material";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import SearchIcon from "@mui/icons-material/Search";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import { getWalletOwnerIdAndNameList } from "../../redux/actions/getWalletOwnerIdAndNameListAction";
import { getProviderTypeAdminList } from "../../redux/actions/adminGetProviderTypeAction"
import { getProviderNamesAdminList } from "../../redux/actions/adminGetProviderNameAction";
import { adminMapIBANProviderLists } from "../../redux/actions/adminMapIbanProviderAction";
import { adminGetIBANProviderLists } from "../../redux/actions/adminGetIbanProviderListAction";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import BackButton from "../../components/BackButton/BackButton";
import SOLogout from "../../components/Logout/SOLogout";
import val from "../../getThemeDetails";
const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});
const AdminIBNProviderMapping = () => {
    const [walletOwnerId, setWalletOwnerId] = useState("");
    const [walletOwnerIdS, setWalletOwnerIdS] = useState("");

    const [provideTypeSearch, setProvideTypeSearch] = useState("");
    const [provideName, setProvideName] = useState("");

    const [provideTypesModal, setProvideTypesModal] = useState("");
    const [provideNameModal, setProvideNameModal] = useState("");

    const [isDefaultModal, setIsDefaultModal] = useState("N");
    const [page, setPage] = useState(0);
    const [Open, setOpen] = React.useState(false);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [isLoading, setIsLoading] = useState(false);

    const [getWalletOwnerIdStatus, setGetWalletOwnerIdStatus] = useState(false);
    const [getWalletOwnerIdResArray, setGetWalletOwnerIdResArray] = useState([]);

    const [getProviderTypeStatus, setGetProviderTypeStatus] = useState(false);
    const [getProviderTypeResArray, setGetProviderTypeResArray] = useState([]);
    const [addOpen, setAddOpen] = React.useState(false);
    const [transactionSubTypesLists, getSetTransactionTypesLists] = useState(false)
    const [getTransactionSubTypeListResArray, setGetTransactionSubTypeListResArray] =
        useState([]);

    const [createIBNMappingStatus, setCreateIBNMappingStatus] = useState("");
    const [createIBNMappingResArray, setCreateIBNMappingResArray] = useState(
        []
    );

    const [getIBNMappingStatus, setGetIBNMappingStatus] = useState(false);
    const [getIBNMappingResArray, setGetIBNMappingResArray] = useState([]);

    const [notificationOpen, setNotificationOpen] = React.useState(false);

    // const partnerloginUser = useSelector(({ login }) => login);
    // var authToken = partnerloginUser.data.AuthToken;
    const regenerateTokenRes = useSelector(
        ({ regenerateToken }) => regenerateToken
    );
    var authToken = regenerateTokenRes.data.AuthToken;
    const classes = useStyles();
    const dispatch = useDispatch();



    const getWalletOwnerIdRes = useSelector(
        ({ getWalletOwnerIdAndNameList }) => getWalletOwnerIdAndNameList
    );
    const getProviderTypeListRes = useSelector(({ adminGetProviderTypesLists }) => adminGetProviderTypesLists);

    const getProviderNameListRes = useSelector(({ adminGetProvidersNamesLists }) => adminGetProvidersNamesLists);

    const getMapIBANProviderListsRes = useSelector(({ adminMapIBANProviderLists }) => adminMapIBANProviderLists);

    const getIbanProviderListRes = useSelector(({ adminGetIBNProviderLists }) => adminGetIBNProviderLists);

    const handleChange = ({ target: { name, value } }) => {
        if (name === "walletOwnerId") {
            setWalletOwnerId(value == "Select Level" ? "" : value);
        }
        if (name === "ProvideTypeSearch") {
            setProvideTypeSearch(value == "Select Provider Type" ? "" : value);
        }
        if (name === "ProvideName") {
            setProvideName(value == "Select Provider Name" ? "" : value);
        }
        if (name === "walletOwnerIdS") {
            setWalletOwnerIdS(value == "Select Level" ? "" : value);
        }

        if (name === "provideTypesModal") {
            setProvideTypesModal(value == "Select Provider Type" ? "" : value);
        }
        if (name === "provideNameModal") {
            setProvideNameModal(value == "Select Provider Name" ? "" : value);
        }
        if (name === "isDefaultModal") {
            setIsDefaultModal(value == "Select Default" ? "" : value);
        }

    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            getWalletOwnerIdAndNameListReq();
            // getIBNMappingListReq()

        }
    }, [regenerateTokenRes.data.status]);

    const getWalletOwnerIdStatusFunc = () => {
        if (getWalletOwnerIdStatus) {
            if (getWalletOwnerIdRes.data.status == "success") {
                setGetWalletOwnerIdResArray(
                    [].concat(getWalletOwnerIdRes.data.ownerList)
                );
            }
            if (getWalletOwnerIdRes.data.status == "failed") {
                setGetWalletOwnerIdResArray(getWalletOwnerIdRes.data);
                if (
                    getWalletOwnerIdRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getWalletOwnerIdRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };

    const getWalletOwnerIdAndNameListReq = () => {
        setGetWalletOwnerIdStatus(true);

        dispatch(
            getWalletOwnerIdAndNameList(
                {
                    loginDetails: {
                        // adminId: "2"
                        adminId: val.adminIDS

                    }
                },
                authToken
            )
        );
    };
    useEffect(() => {
        getWalletOwnerIdStatusFunc();
    }, [getWalletOwnerIdRes.data.status]);

    const getProviderTypeStatusFunc = () => {
        if (getProviderTypeStatus) {
            if (getProviderTypeListRes.data.status == "success") {
                setGetProviderTypeResArray([].concat(getProviderTypeListRes.data.providerType));
            }
            if (getProviderTypeListRes.data.status == "failed") {
                setGetProviderTypeResArray(getProviderTypeListRes.data);
                if (
                    getProviderTypeListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getProviderTypeListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };

    useEffect(() => {
        getProviderTypeStatusFunc();
    }, [getProviderTypeListRes.data.status]);

    const getProviderTypeReq = () => {
        setGetProviderTypeStatus(true);
        dispatch(
            getProviderTypeAdminList(
                {
                    actionCustomerMasterRequestVO: {
                        // adminId: 2,
                        adminId: val.adminIDS

                    }
                },
                authToken
            )
        );
    };
    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            getProviderTypeReq();

        }
    }, [regenerateTokenRes.data.status]);


    const getTransactionSubTypeListFunc = () => {
        if (transactionSubTypesLists && getProviderNameListRes.data) {
            if (getProviderNameListRes.data.status == "success") {
                //console.log("subtypesssss", getTransactionSubTypesRes.data.transactionSubtype)
                // setGetTransactionSubTypeListResArray(
                //     getProviderNameListRes.data.providerNames
                // );
                setGetTransactionSubTypeListResArray([].concat(getProviderNameListRes.data.providerNames));


            }
            if (getProviderNameListRes.data.status == "Failed") {
                setGetTransactionSubTypeListResArray(getProviderNameListRes.data);
                NotificationPopups(
                    "error",
                    "Failed",
                    getProviderNameListRes.data.description
                );
                if (
                    getProviderNameListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getProviderNameListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (getProviderNameListRes.data.status == "failed") {
                setGetTransactionSubTypeListResArray(getProviderNameListRes.data);
                NotificationPopups(
                    "error",
                    "Failed",
                    getProviderNameListRes.data.description
                );
                if (
                    getProviderNameListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getProviderNameListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (getProviderNameListRes.data.status == "NOT FOUND") {
                let transactionSubtype = [getProviderNameListRes.data.status]
                setGetTransactionSubTypeListResArray(transactionSubtype);
                // NotificationPopups(
                // 	"error",
                // 	"Failed",
                // 	getTransactionSubTypesRes.data.description
                // );
                if (
                    getProviderNameListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getProviderNameListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }

    };

    const getTransactionSubTypeListReqApi = () => {
        getSetTransactionTypesLists(true)
        const getTransactionSubTypeListReq = {
            actionCustomerMasterRequestVO: {
                // adminId: 2,
                adminId: val.adminIDS,

                providerType: provideTypeSearch
            }
        };

        return dispatch(
            getProviderNamesAdminList(getTransactionSubTypeListReq, authToken)
        );
    };
    useEffect(() => {
        getTransactionSubTypeListFunc();
    }, [getProviderNameListRes]);


    const getProvidersNameRequest = () => {
        getSetTransactionTypesLists(true)
        const getTransactionSubTypeListReq = {
            actionCustomerMasterRequestVO: {
                // adminId: 2,
                adminId: val.adminIDS,
                
                providerType: provideTypesModal
            }
        };

        return dispatch(
            getProviderNamesAdminList(getTransactionSubTypeListReq, authToken)
        );
    };

    useEffect(() => {
        if (provideTypesModal) {
            getProvidersNameRequest()
        }
    }, [provideTypesModal])

    useEffect(() => {
        if (provideTypeSearch) {
            getTransactionSubTypeListReqApi()
        }
    }, [provideTypeSearch])

    const createProvider = () => {
        setWalletOwnerId('')
        setWalletOwnerIdS('')

        setAddOpen(true);
    };

    const handleClose = () => {

        setAddOpen(false);

    };

    const handleNoticationClose = () => {
        setCreateIBNMappingResArray([]);
        setAddOpen(false);
        setWalletOwnerId("");

        setNotificationOpen(false);
    };

    const createIBNMappingReq = () => {
        setCreateIBNMappingStatus(true);

        const createMappingReq = {
            actionCustomerMasterRequestVO: {

                walletOwnerId: walletOwnerIdS.split("-")[0],
                providerType: provideTypesModal,
                providerName: provideNameModal,
                isDefault: isDefaultModal

            }
        };
        dispatch(adminMapIBANProviderLists(createMappingReq, authToken));

        // console.log("reqqq", createMappingReq)
    };

    const createIBNMappingStatusFunc = () => {
        console.log(getMapIBANProviderListsRes, "/////////////////////////");
        if (createIBNMappingStatus) {
            if (getMapIBANProviderListsRes.data.status == "success") {
                setCreateIBNMappingResArray(getMapIBANProviderListsRes.data);
                setNotificationOpen(true);
                getIBNMappingListReq()
                setIsDefaultModal("N")
                // getRoleMappingListReq();
            }
            if (getMapIBANProviderListsRes.data.status == "failed") {
                setCreateIBNMappingResArray(getMapIBANProviderListsRes.data);
                setNotificationOpen(true);
                if (
                    getMapIBANProviderListsRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getMapIBANProviderListsRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (getMapIBANProviderListsRes.data.status == "INVALID REQUEST") {
                setCreateIBNMappingResArray(getMapIBANProviderListsRes.data);
                setNotificationOpen(true);
            }
        }
    };

    useEffect(() => {
        createIBNMappingStatusFunc();
    }, [getMapIBANProviderListsRes.data.status]);


    const getIBNMappingListReq = () => {
        // setOpen(false);
        setGetIBNMappingStatus(true);
        setIsLoading(true);
        dispatch(
            adminGetIBANProviderLists(
                {
                    actionCustomerMasterRequestVO: {

                        walletOwnerId: walletOwnerId.split("-")[0],
                        providerType: provideTypeSearch,
                        providerName: provideName
                    }
                },
                authToken
            )
        );
    };

    const getIBNMappingStatusFunc = () => {
        if (getIBNMappingStatus) {
            if (getIbanProviderListRes.data.status == "success") {
                setGetIBNMappingResArray(
                    [].concat(getIbanProviderListRes.data.ibanProviderList)
                );
                setIsLoading(false);
            }
            if (getIbanProviderListRes.data.status == "Failed") {
                setGetIBNMappingResArray(getIbanProviderListRes.data);
                setIsLoading(false);
                NotificationPopups(
                    "error",
                    "Failed",
                    getIbanProviderListRes.data.description ||
                    getIbanProviderListRes.description
                );
                if (
                    getIbanProviderListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getIbanProviderListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (getIbanProviderListRes.data.status == "NOT FOUND") {
                setGetIBNMappingResArray(getIbanProviderListRes.data);
                setIsLoading(false);
                NotificationPopups(
                    "error",
                    "NOT FOUND",
                    getIbanProviderListRes.data.description ||
                    getIbanProviderListRes.description
                );
            }
        }
    };

    useEffect(() => {
        getIBNMappingStatusFunc();
    }, [getIbanProviderListRes.data.status]);




    useEffect(() => {
        if (getIbanProviderListRes.data.status == "success") {
            setPage(0);
        }
    }, [getIbanProviderListRes.data.status]);

    // Validation function for "Save" button
    const isSaveButtonEnabled = () => {
        // All required fields must be non-empty and not equal to their placeholder values
        return (
            walletOwnerIdS !== "" && walletOwnerIdS !== "Select Level" &&
            provideTypesModal !== "" && provideTypesModal !== "Select Provider Type" &&
            provideNameModal !== "" && provideNameModal !== "Select Provider Name" &&
            isDefaultModal !== "" && isDefaultModal !== "Select Default" // Ensure this is explicitly set
        );
    };


    return (
        <>
            <Layout>
                <BackButton />
                <Card>
                    <Grid
                        container
                        style={{ padding: "25px", justifyContent: "right" }}
                        spacing={2}
                    >

                        <Grid item md={2} sm={12} xs={12} lg={2}>


                            <CustomButton
                                style={{
                                    padding: "8px",
                                    width: "80px"
                                }}
                                onClick={() => createProvider()}

                            >
                                Create
                            </CustomButton>

                        </Grid>

                    </Grid>
                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px", marginTop: "2rem" }}
                    >
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <TextField
                                select
                                required
                                size="small"
                                color="primary"
                                type="text"
                                label="Owner ID"
                                fullWidth={true}
                                variant="standard"
                                name="walletOwnerId"
                                value={walletOwnerId || "Select Level"}
                                defaultValue={"Select Level" || walletOwnerId}
                                onChange={handleChange}
                            >
                                <MenuItem value="Select Level" selected="Select Level">
                                    Select Owner ID
                                </MenuItem>
                                {getWalletOwnerIdRes.data.ownerList &&
                                    getWalletOwnerIdResArray.map((x) => (
                                        <MenuItem value={x}>{x}</MenuItem>
                                    ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <TextField
                                select
                                required
                                size="small"
                                color="primary"
                                autoFocus={true}
                                type="text"
                                label="Provider Type"
                                fullWidth={true}
                                variant="standard"
                                name="ProvideTypeSearch"
                                // value={roleSearch || "Select Role"}
                                defaultValue={"Select Provider Type" || provideTypeSearch}
                                onChange={handleChange}
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}
                            >
                                <MenuItem value="Select Provider Type" selected="Select Provider Type">
                                    Select Provider Type
                                </MenuItem>
                                {getProviderTypeListRes.data?.providerType && // Added optional chaining
                                    getProviderTypeResArray.map((x, index) => ( // Added index for key
                                        <MenuItem key={index} value={x}>{x}</MenuItem>
                                    ))}
                                {/* {getProviderTypeListRes.data.providerType &&
                                                            getProviderTypeResArray.map((x) => (
                                                                <MenuItem value={x}>{x}</MenuItem>
                                                            ))} */}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                autoFocus={true}
                                type="text"
                                label="Provider Name"
                                fullWidth={true}
                                variant="standard"
                                name="ProvideName"
                                // value={roleSearch || "Select Role"}
                                defaultValue={"Select Provider Name" || provideName}
                                onChange={handleChange}
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}
                            >
                                <MenuItem value="Select Provider Name" selected="Select Provider Name">
                                    Select Provider Name
                                </MenuItem>



                                {Array.isArray(getTransactionSubTypeListResArray) && getTransactionSubTypeListResArray.length > 0 ?
                                    getTransactionSubTypeListResArray.map((c, index) => (
                                        <MenuItem value={c} key={index}>
                                            {c}
                                        </MenuItem>
                                    )) : (
                                        <MenuItem disabled>No Data</MenuItem>
                                    )}

                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={getIBNMappingListReq}

                            >
                                Search <SearchIcon />
                            </CustomButton>

                        </Grid>
                    </Grid>
                </Card>

                {isLoading ? (
                    <LoadingSpinner />


                ) : getIBNMappingResArray.length == undefined ||
                    getIBNMappingResArray.status == "NOT FOUND" ||
                    getIBNMappingResArray.status == "INVALID REQUEST" ||
                    !getIBNMappingStatus ? (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography variant="body1" style={{ fontWeight: "700" }}
                                    className="themeText"

                                >
                                    Report Table
                                </Typography>
                            </Grid>
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="my-3 tableHeaderColor"
                                    variant="secondary"
                                // style={{ backgroundColor: "#00b9f5", color: "white" }}
                                >
                                    No Records Found!
                                </Alert>
                            </Grid>
                        </Grid>
                    </Card>
                ) : (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography variant="body1" style={{ fontWeight: "700" }}
                                    className="themeText"

                                >
                                    Report Table
                                </Typography>
                            </Grid>
                            <TableContainer component={Paper} className="my-3">
                                <Table
                                    className={classes.table}
                                    size="small"
                                    aria-label="a dense table"
                                >
                                    <TableHead>
                                        <TableRow className="tableHeaderColor">
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                ID
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Provider Type
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Provider Name
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Is Default
                                            </TableCell>
                                            {/* <TableCell
                                                                align="center"
                                                                style={{ fontWeight: "bold", color: "white" }}
                                                            >
                                                                Action
                                                            </TableCell> */}
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {getIBNMappingResArray &&
                                            []
                                                .concat(getIBNMappingResArray)
                                                .slice(
                                                    page * rowsPerPage,
                                                    page * rowsPerPage + rowsPerPage
                                                )
                                                .map((row, index) => (
                                                    <TableRow>
                                                        <TableCell align="center">
                                                            {row.id}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.providerType}
                                                        </TableCell>
                                                        <TableCell align="center">{row.providerName}</TableCell>
                                                        <TableCell align="center">
                                                            {row.isDefault}
                                                        </TableCell>

                                                    </TableRow>
                                                ))}
                                    </TableBody>
                                </Table>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={getIBNMappingResArray.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </TableContainer>
                        </Grid>
                    </Card>
                )}
            </Layout>

            <div>
                <Dialog open={addOpen} onClose={handleClose}>
                    <DialogTitle style={{ minWidth: "600px" }}>Mapping Provider</DialogTitle>
                    <DialogContent>

                        <TextField
                            select
                            required
                            size="small"
                            color="primary"
                            type="text"
                            label="Owner ID"
                            fullWidth={true}
                            variant="standard"
                            name="walletOwnerIdS"
                            // value={walletOwnerId || "Select Level"}
                            value={walletOwnerIdS || "Select Level"}

                            defaultValue={"Select Level" || walletOwnerIdS}
                            onChange={handleChange}
                        >
                            <MenuItem value="Select Level" selected="Select Level">
                                Select Owner ID
                            </MenuItem>
                            {getWalletOwnerIdRes.data.ownerList &&
                                getWalletOwnerIdResArray.map((x) => (
                                    <MenuItem value={x}>{x}</MenuItem>
                                ))}
                        </TextField>
                        <TextField
                            select
                            required

                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="Provider Type"
                            fullWidth={true}
                            name="provideTypesModal"
                            defaultValue={"Select Provider Type" || provideTypesModal}


                            variant="standard"
                            onChange={handleChange}
                            InputProps={{
                                sx: {
                                    "&:before": { borderBottomColor: "gray" }, // before focus
                                    "&:after": { borderBottomColor: "gray" },  // after focus
                                },
                            }}
                            InputLabelProps={{
                                sx: { color: 'gray' }, // Optional: if you want the label to be white
                            }}
                        >

                            <MenuItem value="Select Provider Type" selected="Select Provider Type">
                                Select Provider Type
                            </MenuItem>
                            {getProviderTypeListRes.data?.providerType && // Added optional chaining
                                getProviderTypeResArray.map((x, index) => ( // Added index for key
                                    <MenuItem key={index} value={x}>{x}</MenuItem>
                                ))}
                        </TextField>

                        <TextField
                            required
                            style={{ marginTop: "10px" }}
                            select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="Provider Name"
                            fullWidth={true}
                            variant="standard"

                            name="provideNameModal"
                            defaultValue={"Select Provider Name" || provideNameModal}

                            // onChange={(e) => onInputChange(e)}
                            onChange={handleChange}

                        >
                            <MenuItem value="Select Provider Name" selected="Select Provider Name">
                                Select Provider Name
                            </MenuItem>



                            {Array.isArray(getTransactionSubTypeListResArray) && getTransactionSubTypeListResArray.length > 0 ?
                                getTransactionSubTypeListResArray.map((c, index) => (
                                    <MenuItem value={c} key={index}>
                                        {c}
                                    </MenuItem>
                                )) : (
                                    <MenuItem disabled>No Data</MenuItem>
                                )}

                        </TextField>
                        <TextField
                            select
                            autoFocus
                            margin="dense"
                            id="name"
                            label="Is Default"
                            type="name"
                            fullWidth
                            variant="standard"
                            // value={fraudCheckAllow || "Select Fraud Check Allowed"}
                            defaultValue={isDefaultModal || "Select Default"}
                            name="isDefaultModal"
                            onChange={handleChange}
                            InputProps={{
                                sx: {
                                    "&:before": { borderBottomColor: "gray" }, // before focus
                                    "&:after": { borderBottomColor: "gray" },  // after focus
                                },
                            }}
                            InputLabelProps={{
                                sx: { color: 'gray' }, // Optional: if you want the label to be white
                            }}
                        >
                            {/* <MenuItem value="Select Fraud Check Allowed">
                                                                        Select Fraud Check Allowed
                                                                    </MenuItem> */}
                            <MenuItem value="Y">Y</MenuItem>
                            <MenuItem value="N">N</MenuItem>
                        </TextField>




                    </DialogContent>
                    <DialogActions style={{ padding: "14px" }}>
                        <CustomButton
                            style={{
                                backgroundColor: "#00b9f5",
                                color: "white"
                            }}
                            variant="contained"
                            onClick={handleClose}
                        >
                            Cancel
                        </CustomButton>
                        <CustomButton
                            style={{
                                backgroundColor: "#00b9f5",
                                color: "white"
                            }}
                            variant="contained"
                            disabled={!isSaveButtonEnabled()}
                            onClick={createIBNMappingReq}
                        >
                            Save
                        </CustomButton>
                    </DialogActions>
                </Dialog>
            </div>

            {createIBNMappingResArray.status == "success" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {createIBNMappingResArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {createIBNMappingResArray.status == "failed" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {createIBNMappingResArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {createIBNMappingResArray.status == "INVALID REQUEST" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {createIBNMappingResArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
        </>
    )
}

export default AdminIBNProviderMapping;